// @flow
import cn from 'classnames';
import React from 'react';
import styles from './styles.local.less';

type TProps = {
    big?: boolean,
    className?: string,
    opacity?: boolean,
    warning?: boolean,
};

/**
 * Иконка прелоадера с прогрессом
 * @returns React-компонент
 */
export const Loader = ({big, className, opacity, warning}: TProps) => (
    <div className={cn(className, styles.loader, {[styles.loaderBig]: big}, {[styles.loaderOpacity]: opacity}, {[styles.loaderWarning]: warning})} />
);
